export function showConfirmationModal(modalElement,
                                      htmxIssueRequest,
                                      title = undefined,
                                      message = undefined,
                                      confirmButtonText = undefined,
                                      cancelButtonText= undefined) {
  let {titleElement, messageElement, confirmButton, cancelButton, cancelHeader, processingDiv, actionsDiv} = getModalElements(modalElement);

  let removeEventListeners;

  let confirmHandler = (evt) => {
    evt.preventDefault();
    hideElement(actionsDiv);
    showElement(processingDiv);

    if (htmxIssueRequest) htmxIssueRequest();
  };

  // export function initULModals() {
  //   const mod
  // }

  let cancelHandler = (evt) => {
    evt.preventDefault();
    if(removeEventListeners) removeEventListeners();
    hideModal(modalElement, actionsDiv, processingDiv);
  };

  let afterRequestHandler = (evt) => {
    if(removeEventListeners) removeEventListeners();

    let hxRedirect = evt.detail.xhr.getResponseHeader("HX-Redirect");

    // do not hide modal if a hx-redirect should be performed
    if(!hxRedirect) {
      hideModal(modalElement, actionsDiv, processingDiv);
    }

    let status = evt.detail.xhr.status;
    let successful = status >= 200 && status < 300;

    if(!successful) {
      alert('An error occurred. Please try again.');
    }
  };

  removeEventListeners = setupRemoveEventListeners(confirmButton, confirmHandler, cancelButton, cancelHeader, cancelHandler, afterRequestHandler);

  setModalText(title, titleElement, message, messageElement, confirmButtonText, confirmButton, cancelButtonText, cancelButton);

  setupEventListeners(confirmButton, confirmHandler, cancelButton, cancelHeader, cancelHandler, afterRequestHandler);

  showElement(modalElement);
}

function getModalElements(modalElement) {
  const titleElement = modalElement.querySelector(".confirm-title");
  const messageElement = modalElement.querySelector(".confirm-message");
  const confirmButton = modalElement.querySelector("button.confirm-button")
  const cancelButton = modalElement.querySelector("button.cancel-button")
  const cancelHeader = modalElement.querySelector("i.ul-modal__headerClose")
  const processingDiv = modalElement.querySelector("div.htmx-modal-processing")
  const actionsDiv = modalElement.querySelector("span.htmx-modal-actions")

  return {titleElement, messageElement, confirmButton, cancelButton, cancelHeader, processingDiv, actionsDiv};
}

function setModalText(title, titleElement, message, messageElement, confirmButtonText, confirmButton, cancelButtonText, cancelButton) {
  if (title !== undefined)
    titleElement.innerHTML = title;

  if (message !== undefined)
    messageElement.innerHTML = message;

  if (confirmButtonText !== undefined)
    confirmButton.innerHTML = confirmButtonText;

  if (cancelButtonText !== undefined)
    cancelButton.innerHTML = cancelButtonText;
}

function setupEventListeners(confirmButton, confirmHandler, cancelButton, cancelHeader, cancelHandler, afterRequestHandler) {
  confirmButton.addEventListener('click', confirmHandler);
  cancelButton.addEventListener('click', cancelHandler);
  cancelHeader?.addEventListener('click', cancelHandler);
  document.body.addEventListener('htmx:afterRequest', afterRequestHandler);
}

function setupRemoveEventListeners(confirmButton, confirmHandler, cancelButton, cancelHeader , cancelHandler, afterRequestHandler) {
  return () => {
    confirmButton.removeEventListener('click', confirmHandler, false);
    cancelButton.removeEventListener('click', cancelHandler, false);
    cancelHeader?.removeEventListener('click', cancelHandler, false);
    document.body.removeEventListener('htmx:afterRequest', afterRequestHandler, false);
  };
}

function hideModal(modalElement, actionsDiv, processingDiv) {
  hideElement(modalElement);
  showElement(actionsDiv);
  hideElement(processingDiv);
}

function hideElement(element) {
  element.classList.add('hidden');
}

function showElement(element) {
  element.classList.remove('hidden');
}
